import { render, staticRenderFns } from "./ReportBin.vue?vue&type=template&id=469b2fcd"
import script from "./ReportBin.vue?vue&type=script&lang=js"
export * from "./ReportBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports